define('gameday-business-rules/gameday-business-rules',['require','exports','module','jquery'],function(require, exports, module) {
    var jquery = require('jquery');

    var instance = {
        options : {
            hideVideoUntilFinal: false,
            hideColorFeedSpringTraining: false,
            hideColorFeedPrior2015: true,
            hideStatcastTabSpringTraining: true,
            panelTabs : {}
        }
    }

    function copyToRules(source){
        if(source != undefined){
            $.extend(true,instance.options,source||{});
        }
    }

    return {

        setRules  : function(cfg){
            copyToRules(cfg);
        },

        getInstance: function(cfg) {
            // apply new rules
            copyToRules(cfg);

            // return a clone
            return $.extend(true,{},instance);
        }

    };

});
